/**
 * Created by Arif Topcu in 2019
 */

import React, {useCallback, useMemo} from 'react';
import Combobox from '@ls/react-combobox-grid';
import {useDispatch, useSelector} from 'react-redux';
import {calcTypeOptions} from 'state/Constants/CalcType';
import SelectionState from 'state/selections/SelectionState';
import ComplicationMiniSelector from 'components/ComplicationMiniSelector';
import IssuerCountTypes from 'state/issuerCount/IssuerCountTypes';
import IssuerCountDefinition from 'state/issuerCount/IssuerCountDefinition';
import {setDefinition, setDefinitions} from 'state/issuerCount/actions';
import {selectDefinitions} from 'state/issuerCount/selectors';
import {Cell, Grid} from "styled-css-grid";

const issuerCountDefinitionTypeOptions = IssuerCountTypes.map(v => ({label: v, value: v}));

const IssuerCountComplication = ({complicationDefinition: definition, setComplication: setDefinition}) => {
  const [setIssuerCountType, setCalcType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setIssuerCountType(value)),
      (value) => setDefinition(definition.setCalcType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={2}>
        <Combobox
          options={issuerCountDefinitionTypeOptions}
          clearable={false}
          onChange={setIssuerCountType}
          value={definition.issuerCountType}
          label="Issuer Count Type:"
          variation={0}
          size={'S'}
          gridHeight={175}
        />
      </Cell>
      <Cell>
        <Combobox
          options={calcTypeOptions}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          clearable={false}
          variation={0}
          size={'S'}
          gridHeight={120}
        />
      </Cell>
    </Grid>
  );
};

const IssuerCountSelector = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const dispatch = useDispatch();

  const setComplicationDefinition = useCallback((idx, def) => dispatch(setDefinition(idx, def)), [dispatch]);
  const setComplicationDefinitions = useCallback((def) => dispatch(setDefinitions(def)), [dispatch]);

  return (
    <ComplicationMiniSelector
      selectedComplicationDefinitions={definitions}
      setComplicationDefinition={setComplicationDefinition}
      setComplicationDefinitions={setComplicationDefinitions}
      ComplicationDefinitionClass={IssuerCountDefinition}
      Complication={IssuerCountComplication}
      complicationTitle={"Issuer Count"}
    />
  );
};

export default IssuerCountSelector;
